module.exports = __webpack_public_path__ + "img/ic_file-exclamation.9a43db49.svg";